// Alpine component registrations — all x-data must reference a named component
// so this file is compatible with the @alpinejs/csp build (no unsafe-eval).
document.addEventListener('alpine:init', function () {

    // ── Basket toast ─────────────────────────────────────────────────────────
    // Used in _Layout.cshtml: x-data="basketToast"
    Alpine.data('basketToast', function () {
        return {
            visible: false,
            _timer: null,
            show: function () {
                this.visible = true;
                if (this._timer) clearTimeout(this._timer);
                var self = this;
                this._timer = setTimeout(function () { self.visible = false; }, 3000);
            },
            get toastClass() {
                return this.visible ? 'basket-toast' : 'basket-toast basket-toast-hidden';
            }
        };
    });

    // ── Image gallery ─────────────────────────────────────────────────────────
    // Used in ProductDetails.cshtml: x-data="imageGallery" data-initial-url="..."
    // Reads the initial active image URL from the element's data-initial-url attribute
    // so no inline object literal is needed in the markup.
    Alpine.data('imageGallery', function () {
        return {
            active: '',
            init: function () {
                this.active = this.$el.dataset.initialUrl || '';
            }
        };
    });

    // ── Confirmation form ─────────────────────────────────────────────────────
    // Used on delete forms: x-data="confirmableForm"
    //   x-on:submit.prevent="confirmAndSubmit('Are you sure?')"
    // Calls form.submit() (not a submit event) so it bypasses this handler.
    Alpine.data('confirmableForm', function () {
        return {
            confirmAndSubmit: function (msg) {
                if (window.confirm(msg)) this.$el.submit();
            }
        };
    });
});
